module.exports = __webpack_public_path__ + "img/seguranca_de_transito.828edfd8.png";